<template>
  <transition name="fade">
    <div v-if="isMounted && isGateOpen" class="age-gate">
      <div class="gate-container">
        <div class="gate">
          <Header />
          <div class="banner-wrapper">
            <div class="row banner">
              <div class="columns small-10 medium-6">
                <h1>LOTERIA</h1>
                <img src="/images/2026/banner_win.svg" alt="Wygraj czteropak lub piwo" class="banner-logo" />
              </div>
              <div class="columns small-10 medium-4 large-3">
                <img src="/images/2026/kapsle.png" alt="Obrazek prezentuje zwycięskie kapsle" class="banner-logo" />
              </div>
            </div>
          </div>
          <div class="input-wrapper">
            <BirthDateForm ref="birthDateForm" design-version="2026" @valid="onDateValid" />
          </div>
          <FooterSimple />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BirthDateForm from '../components/form-items/BirthDateForm.vue'
import Header from './common/Header.vue'
import FooterSimple from './common/FooterSimple.vue'

const setCookies = (key, value) => {
  const DOMAIN = window.location.hostname
    .split('.')
    .splice(-2)
    .join('.')
  const expireDate = new Date().setDate(new Date().getDate() + 365)
  document.cookie = `${key}=${JSON.stringify(value)}; domain=${DOMAIN}; expires=${expireDate}; path=/`
}
const getCookies = key => {
  const name = `${key}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export default {
  name: 'Gate2026',
  components: {
    BirthDateForm,
    Header,
    FooterSimple
  },
  data: () => ({
    isMounted: false
  }),
  computed: {
    isGateOpen() {
      return this.$store.state.isGateOpen
    }
  },
  async mounted() {
    await this.$nextTick()

    if (!getCookies('valid-age')) {
      this.$gtag && this.$gtag.event('gate')
      if (!this.isGateOpen) this.$store.commit('toggleGate')
      this.isMounted = true
    } else {
      setTimeout(() => {
        if (this.isGateOpen) {
          this.$store.commit('toggleGate')
          document.body.classList.add('age-confirmed')
        }
        this.isMounted = true
      }, 300)
    }
  },
  methods: {
    onDateValid() {
      this.$gtag && this.$gtag.event('gate_pass')
      this.$store.commit('toggleGate')
      setCookies('valid-age', true)
      document.body.classList.add('age-confirmed')
    }
  }
}
</script>

<style lang="scss" scoped>
$gate-background-color: $background-color;
$gate-z-index: z(gate);
$text-color: #fff;

.age-gate {
  @include fill-space;
  bottom: 0;
  min-height: $vh;
  z-index: $gate-z-index;
  background: $gate-background-color;
  color: $text-color;
  overflow: scroll;
  overflow-x: hidden;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: 1px;
  line-height: 1.6;
  font-style: normal;
  font-weight: 400;

  @include media-up(lg) {
    overflow: auto;
  }
}

.gate-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.gate {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .banner-wrapper {
    flex-grow: 1;

    .banner {
      align-items: flex-end;
    }
  }

  .input-wrapper {
    margin: rem-calc(16) 0;

    @include breakpoint(large) {
      margin: rem-calc(32) 0;
    }
  }
}

.gate-logo {
  margin-top: 31px;
  width: 84px;
  height: auto;

  @include media-up(md) {
    margin-top: 100px;
    width: 165px;
  }

  @include media-up(lg) {
    margin-top: 0;
    width: 100px;
  }

  @include media-up(xxl) {
    width: 162px;
  }
}

.cookie-info {
  font-size: 10px;
  color: $text-color;
  text-transform: uppercase;
  line-height: 1.5;
  letter-spacing: 0.5px;
  padding: 62px 31px 35px;

  @include media-up(md) {
    display: flex;
    align-items: flex-start;
  }

  &__first {
    font-family: $bold-font;

    @include media-up(md) {
      margin-right: 54px;
    }

    @include media-up(xxl) {
      margin-right: 127px;
    }
  }

  &__second {
    font-family: $regular-font;

    @include media-down(md) {
      margin-top: 17px;
    }
  }
}

.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.only-mobile {
  @include hide-up(md);
}

.not-mobile {
  @include hide-down(md);
}

.cookie-info .underline {
  margin-left: 2px;
}
</style>
